module.exports = __webpack_public_path__ + "img/report-bg1.033784f7.png";